import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "badge-inactive"
}
const _hoisted_6 = {
  key: 0,
  class: "user-access-block"
}
const _hoisted_7 = { class: "user-access-count" }
const _hoisted_8 = { class: "user-pick-login" }
const _hoisted_9 = {
  key: 1,
  class: "modal-hint"
}
const _hoisted_10 = {
  key: 2,
  class: "modal-hint"
}
const _hoisted_11 = { class: "admin-modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: _normalizeClass(["ion-no-border events-page-header", { 'page-header--scrolled': _ctx.headerScrolled }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: "",
                    "default-href": "/useful-links"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Полезные ссылки (админ)", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCreate()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.addOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_content, {
        class: "main-background events-content",
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Загрузка..."))
              : (_openBlock(), _createBlock(_component_ion_list, {
                  key: 1,
                  lines: "full"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (row) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        key: row.id,
                        class: "link-item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", null, _toDisplayString(row.title), 1),
                              _createElementVNode("p", null, [
                                (row.visibleToAll)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Для всех"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_4, "Пользователей: " + _toDisplayString(row.userIds?.length ?? 0), 1)),
                                _createTextVNode(" · порядок " + _toDisplayString(row.sortOrder) + " ", 1),
                                (!row.active)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "выкл"))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_button, {
                            fill: "clear",
                            slot: "end",
                            class: "link-row-edit-btn",
                            onClick: ($event: any) => (_ctx.openEdit(row))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_ion_button, {
                            fill: "clear",
                            slot: "end",
                            color: "danger",
                            onClick: ($event: any) => (_ctx.confirmDelete(row))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
          ]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.modalOpen,
            onDidDismiss: _ctx.closeModal,
            class: "useful-links-editor-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.editingId ? 'Редактирование' : 'Новая ссылка'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, { class: "ion-padding useful-links-modal-content" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, { class: "field" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("Заголовок", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        modelValue: _ctx.form.title,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.title) = $event)),
                        placeholder: "Название"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { class: "field" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("Целевой URL", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        modelValue: _ctx.form.targetUrl,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.targetUrl) = $event)),
                        placeholder: "https://…"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { class: "field" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("Видна всем авторизованным", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_toggle, {
                        modelValue: _ctx.form.visibleToAll,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.visibleToAll) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (!_ctx.form.visibleToAll)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "user-access-hint" }, "Доступ отдельным пользователям", -1)),
                        _createElementVNode("p", _hoisted_7, "Выбрано: " + _toDisplayString((_ctx.form.userIds || []).length), 1),
                        _createVNode(_component_ion_searchbar, {
                          modelValue: _ctx.userPickerFilterQuery,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userPickerFilterQuery) = $event)),
                          placeholder: "Поиск по имени, фамилии или логину",
                          debounce: 200,
                          class: "admin-add-users-search"
                        }, null, 8, ["modelValue"]),
                        (_ctx.users.length)
                          ? (_openBlock(), _createBlock(_component_ion_list, {
                              key: 0,
                              lines: "full",
                              class: "user-pick-list"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsersForAccess, (u) => {
                                  return (_openBlock(), _createBlock(_component_ion_item, {
                                    key: String(u.id),
                                    class: "user-pick-item"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_checkbox, {
                                        slot: "start",
                                        checked: _ctx.isUserSelected(u.id),
                                        onIonChange: ($event: any) => (_ctx.onUserAccessChange(u, $event))
                                      }, null, 8, ["checked", "onIonChange"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h3", null, _toDisplayString(_ctx.userDisplayName(u)), 1),
                                          _createElementVNode("p", _hoisted_8, _toDisplayString(u.login), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("p", _hoisted_9, "Загрузите список пользователей (обновите страницу).")),
                        (_ctx.users.length && !_ctx.filteredUsersForAccess.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Ничего не найдено."))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_item, { class: "field" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("Порядок сортировки", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        type: "number",
                        modelValue: _ctx.form.sortOrder,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.sortOrder) = $event)),
                        modelModifiers: { number: true }
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { class: "field" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode("Активна", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_toggle, {
                        modelValue: _ctx.form.active,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.active) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      class: "admin-primary-btn",
                      onClick: _ctx.save,
                      disabled: _ctx.saving
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.saving ? 'Сохранение…' : 'Сохранить'), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      fill: "outline",
                      class: "admin-outline-btn",
                      onClick: _ctx.closeModal
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("Закрыть", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open", "onDidDismiss"])
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}